<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑管理员</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item prop="companyId" label="所属客户">
                  <el-select
                    v-model="model.companyId"
                    :disabled="disabled"
                    placeholder="请选择..."
                    @change="selectCompany"
                  >
                    <el-option
                      v-for="role in companyList"
                      :key="role.id"
                      :label="role.companyFullName"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="roleId" label="管理角色">
                  <el-select
                    v-model="model.roleId"
                    placeholder="请选择..."
                    :disabled="roleType == 2"
                  >
                    <el-option
                      v-for="role in roleList"
                      :key="role.id"
                      :label="role.title"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="username" label="登录账号">
                  <el-input
                    v-model="model.username"
                    :disabled="model.id > 0"
                    placeholder="唯一名称，不可重复、英文数字"
                  ></el-input>
                </el-form-item>

                <el-form-item label="登录密码" v-if="model.id > 0">
                  <el-input
                    show-password
                    v-model="model.password"
                    placeholder="登录密码,不修改请留空"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password" label="登录密码" v-else>
                  <el-input
                    show-password
                    v-model="model.password"
                    placeholder="必填，最少6位英文字母"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="realName" label="真实姓名">
                  <el-input v-model="model.realName" placeholder=""></el-input>
                </el-form-item>
                <el-form-item prop="mobile" label="手机号码">
                  <el-input v-model="model.mobile" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="账户状态">
                  <el-radio-group v-model="model.status">
                    <el-radio-button label="0">正常</el-radio-button>
                    <el-radio-button label="1">禁用</el-radio-button>
                  </el-radio-group>
                </el-form-item>

                <el-form-item prop="appId" label="appId" v-if="roleType == 2">
                  <el-input v-model="model1.appId" disabled></el-input>
                </el-form-item>
                <el-form-item prop="sign" label="sign" v-if="roleType == 2">
                  <el-input v-model="model1.sign" disabled></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      disabled: true,
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      roleList: [], //角色列表
      companyList: [], //公司列表
      model: {
        gmtCreate: "2022-01-02 16:25:41",
        createdBy: "system",
        modifiedBy: "system",
        gmtModified: "2022-01-02 16:25:51",
        id: "",
        companyId: "",
        username: "",
        realName: "",
        roleId: "",
        passwordHash: null,
        mobile: "",
        status: 0,
        companyName: "",
        fullCompanyName: "",
      },
      model1: {
        appId: "",
        sign: "",
      },
      roleType: "",
      rules: {
        companyId: [
          { required: true, message: "请选择所属客户", trigger: "change" },
        ],
        roleId: [
          { required: true, message: "请选择管理角色", trigger: "change" },
        ],
        username: [
          { required: true, message: "请输入登录用户名", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_@]*$/,
            message: "只能是字母数字下划线",
            trigger: "blur",
          },
          {
            min: 2,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "blur",
          },
        ],
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 3 到 128 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          { min: 6, max: 128, message: "密码长度在至少6位", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面

      // //加载公司列表
      // AxiosAjax({
      //     url: '/cabinet/company/page?index=1&size=9000',
      //     loading: true,
      //     success: function (res) {
      //         //console.log(res.data)
      //         _this.companyList = res.data.data.content
      //     }
      // });

      var companyId = window.localStorage.getItem("fx_login_companyId");
      var companyFullName = window.localStorage.getItem("fx_login_company");
      _this.companyList.push({
        companyFullName: companyFullName,
        id: companyId,
      });

      let id = _this.$route.query.id || null; //获取ID
      if (id) {
        AxiosAjax({
          url: "/cabinet/user/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
            _this.roleType = res.data.data.roleType;
            console.log(_this.model);
            _this.getRoleList(_this.model.companyId);
          },
        });
      } else {
        _this.model.companyId =
          window.localStorage.getItem("fx_login_companyId");
        _this.getRoleList(_this.model.companyId);
      }
    },
    selectCompany: function (_val) {
      this.getRoleList(_val);
    },
    getRoleList: function (companyId) {
      let _this = this; //当前页面
      //加载角色列表
      AxiosAjax({
        url: "/cabinet/role/search?index=1&size=900&companyId=" + companyId,
        loading: true,
        success: function (res) {
          //console.log(res.data)
          _this.roleList = res.data.data;
        },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });
      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > 0) {
          AxiosAjax({
            method: "put",
            url: "/cabinet/user/update",
            data: _this.model,
            loading: true,
            successMsg: "修改账号已成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "ManagerList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/user/save",
            data: _this.model,
            loading: true,
            successMsg: "新增账号已成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();
              _this.$router.push({ name: "ManagerList" });
            },
          });
        }
      });
    },
    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Manager/ManagerEdit.vue